import { useEffect } from "react";
import scrollMonitor from "scrollmonitor";
import anime from "animejs/lib/anime.es.js";

const called: any = [];

const useScrollAnimation = (refs: any, animationConfig: object, service: any) => {
    useEffect(() => {
        if (!refs.current.length) return;
        console.log(called);
        if (!called.includes(JSON.stringify(service))) {
            console.log("used effect");

            const watchers = refs.current.map((ref: any) => {
                if (!ref) return null;
                const watcher = scrollMonitor.create(ref);

                watcher.enterViewport(() => {
                    console.log(ref);
                    called.push(JSON.stringify(service));

                    anime({
                        targets: ref,
                        ...animationConfig,
                    });
                }, true);

                return watcher;
            });

            return () => {
                watchers.forEach((watcher: any) => watcher.destroy());
            };
        }
    }, [refs, animationConfig, service]);
};

export default useScrollAnimation;
